import React, { useEffect, useState, useContext } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Button,
  Badge,
  Container,
  Grid
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import studioApi from '../../api/studioApi';
import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import filesApi from '../../api/filesApi';
import KpiCard from '../../components/KpiCard';
import { formatDate } from '../../utils/dateFormatter';
import ProtectedAction from '../../components/ProtectedAction';

export default function DashboardStudioMobile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [studio, setStudio] = useState(null);
  const [documenti, setDocumenti] = useState([]);
  const [totContribuenti, setTotContribuenti] = useState(0);
  const [scadenzeProssime, setScadenzeProssime] = useState(0);
  const [scadenzeScadute, setScadenzeScadute] = useState(0);
  const [totDocumenti, setTotDocumenti] = useState(0);
  const [totRateSaltate, setTotRateSaltate] = useState(0);

  useEffect(() => {
    fetchStudio();
    fetchContribuenti();
    fetchDocumenti();
  }, [id]);

  const fetchStudio = async () => {
    const res = await studioApi.get(id);
    setStudio(res.data);
  };

  const fetchContribuenti = async () => {
    const res = await contribuenteApi.listbystudio(id, { page: 0, size: 10000 });
    setTotContribuenti(res.data.content.length);
  };

  const fetchDocumenti = async () => {
    const res = await documentoApi.listbystudio(user.userId, { page: 0, size: 10 });
    const docs = res.data.content || [];

    let prossime = 0, scadute = 0, rate = 0;

    docs.forEach(d => {
      rate += d.rateSaltate || 0;
      d.scadenze?.forEach(s => {
        const diff = (new Date(s.data) - new Date()) / 86400000;
        if (diff < 0) scadute++;
        else if (diff <= 7) prossime++;
      });
    });

    setDocumenti(docs);
    setTotDocumenti(docs.length);
    setTotRateSaltate(rate);
    setScadenzeProssime(prossime);
    setScadenzeScadute(scadute);
  };

  const openPdf = async (path) => {
    const res = await filesApi.getfile(path);
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    window.open(url, '_blank');
    URL.revokeObjectURL(url);
  };

  if (!studio) return <div>Loading...</div>;

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>

      {/* HEADER */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {studio.username || studio.nome}
        </Typography>
      </Box>

      {/* KPI */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} md={3}><KpiCard title="Contribuenti" value={totContribuenti} /></Grid>
        <Grid item xs={6} md={3}><KpiCard title="Documenti" value={totDocumenti} /></Grid>
        <Grid item xs={6} md={3}><KpiCard title="Rate saltate" value={totRateSaltate} color="error" /></Grid>
        <Grid item xs={6} md={3}><KpiCard title="Scadenze prossime" value={scadenzeProssime} color="warning" /></Grid>
        <Grid item xs={6} md={3}><KpiCard title="Scadenze scadute" value={scadenzeScadute} color="error" /></Grid>
      </Grid>

      <Grid container spacing={3}>

        {/* CONTRATTO */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Contratto
              </Typography>

              <Typography>Tipo: {studio.contratto?.tipocontratto?.tipo || '—'}</Typography>
              <Typography>Canone: € {studio.contratto?.canoneAnnuo || '—'}</Typography>
              <Typography>Scadenza: {formatDate(studio.contratto?.dataFine) || '—'}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* DOCUMENTI */}
        <Grid item xs={12} md={8}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Documenti recenti
              </Typography>

              <Stack spacing={1.5}>
                {documenti.map(d => (
                  <Accordion
                    key={d.id}
                    sx={{
                      borderRadius: 2,
                      '&:before': { display: 'none' }
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>

                        <Typography sx={{ fontWeight: 500 }}>
                          {d.tipo}
                        </Typography>

                        {d.rateSaltate > 0 && (
                          <Box sx={{ mr: 2 }}>
                            <Badge color="error" badgeContent={d.rateSaltate}>
                              <span />
                            </Badge>
                          </Box>
                        )}

                      </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Typography variant="body2">
                        {d.contribuente?.nome} {d.contribuente?.cognome}
                      </Typography>

                      <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
                        Creato il {formatDate(d.dataCreazione)}
                      </Typography>

                      <Stack spacing={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => navigate(`/documenti/${d.id}`)}
                        >
                          Dettaglio
                        </Button>
                      </Stack>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Stack>

            </CardContent>
          </Card>
        </Grid>

      </Grid>

    </Container>
  );
}
